// extracted by mini-css-extract-plugin
export var blue = "dot-module--blue--ODSpH";
export var dot = "dot-module--dot--aueFp";
export var dotWrapper = "dot-module--dot-wrapper--BaHQp";
export var orange = "dot-module--orange--UimTU";
export var wrapper = "dot-module--wrapper--DCIl5";